import React from 'react';
import './PlaceholderPage.css';

export default function PlaceholderPage({ title }) {
  return (
    <div className="placeholder-page">
      <div className="placeholder-content">
        <div className="placeholder-icon">🚧</div>
        <h2>{title || 'Page'}</h2>
        <p>This page is yet to be built.</p>
      </div>
    </div>
  );
}
